import { useSnackbar } from 'notistack';
import { Quotes } from 'quotes/quotes';
import { Redirect, useParams } from 'react-router-dom';
import { ROUTES } from 'routing/routes';
import { trace } from '@opentelemetry/api';
import { ProvideQuoteListState } from 'shared/contexts';
import { useBrandRedirect } from 'shared/hooks';
import { useAuthState } from 'shared/stores';
import { Brands } from 'shared/types';
import { useEffect } from 'react';

export function QuotesResolver() {
  const { brand } = useParams<{ brand: Brands }>();
  const authState = useAuthState();
  const user = authState.user.get();
  const [redirect] = useBrandRedirect(user?.insightClaims || '', sites => !sites.includes(brand));
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const tracer = trace.getTracer('page-view-trace');
    const span = tracer.startSpan('page', {
      attributes: {
        pageview: brand,
      },
    });
    span.end();
  }, [brand]);

  if (!user) {
    return null;
  }

  if (redirect) {
    enqueueSnackbar(`You are not allowed to view the quotes for this brand: ${brand} or it doesn't exist`, {
      variant: 'error',
    });
    return <Redirect to={ROUTES.brands} />;
  }

  return (
    <ProvideQuoteListState brand={brand}>
      <Quotes brand={brand} user={user} />
    </ProvideQuoteListState>
  );
}
